import {createContext} from 'react';

import type {CallHistoryService} from '../services/CallHistory.service';

export const CallHistoryContext = createContext<CallHistoryService | undefined>(
    undefined,
);
